import React, { useEffect, useState, useCallback, Suspense } from 'react';
import block from 'bem-cn';
import { Route, Switch, useLocation, useHistory, Redirect } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { Lines } from 'react-preloaders';

import { languages } from 'services/locale';
import { actions as authAction } from './features/Auth';
import { actions as localeActions } from './features/locale';
import Notify from 'features/Notify/view';
import { Rules } from './components/Rules';
import { Game } from './features/Game';
import { SocketErrorBoundary } from 'features/SocketErrorBoundary';

import './App.scss';

const Music = React.lazy(() => import('./components/Music'));

const App = ({ lang, homeUrl }) => {
  const b = block('app');
  const [isUserActivity, setUserActivity] = useState(false);
  const { colorTheme } = useSelector(state => state.auth);
  const isAuth = useSelector(state => state.auth.isAuth);
  const tempToken = useSelector(state => state.auth.token);
  const tempHomeUrl = useSelector(state => state.auth.homeUrl);
  const tempLang = useSelector(state => state.locale.lang);
  const { isGameSocketError, gameSocketError } = useSelector(state => state.socketError);
  const location = useLocation();
  const history = useHistory();
  const dispatch = useDispatch();

  const userActivityClick = useCallback(f => isUserActivity ? f :
    setUserActivity(true),
  [isUserActivity]);

  useEffect(() => {
    if (location.search.indexOf(tempToken) === -1 && tempToken !== null) {
      history.replace(`${location.pathname}?token=${tempToken}&lang=${tempLang}&homeUrl=${tempHomeUrl}`)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname, location.search, tempToken])

  useEffect(() => {
    dispatch(authAction.setPlatform());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [navigator.userAgent, dispatch])

  useEffect(() => {
    dispatch(localeActions.changeLang(languages[lang] ? lang : 'fr'))
  }, [dispatch, lang])

  useEffect(() => {
    dispatch(authAction.setHomeUrl(homeUrl))
  }, [dispatch, homeUrl])

  useEffect(() => {
    const elementsForTheming = [
      document.getElementById('root'),
      document.getElementById('notify'),
    ];

    elementsForTheming.forEach(el => el.classList.add(`theme-${colorTheme}`));

    return () => {
      elementsForTheming.forEach(el => el.classList.remove(`theme-${colorTheme}`));
    };
  }, [colorTheme]);

  return isGameSocketError ? <SocketErrorBoundary error={gameSocketError} /> : (
    <React.Fragment>
      <Lines color="var(--accent-color)" background="var(--settings-background)" customLoading={!isAuth} />
      {isAuth ? <div className={b()} onMouseMove={userActivityClick} onTouchMove={userActivityClick} >
        <Notify />
        <Switch>
          <Redirect from="/" to="/game" exact />
          <Route exact key="/" path="/" component={Game} />
          <Route exact key="/game" path="/game" component={Game} />
          <Route exact key="/rules" path="/rules" component={Rules} />
        </Switch>
      </div> : null}
      {isUserActivity && <Suspense fallback={null}>
        <Music />
      </Suspense>}
    </React.Fragment>

  );
}

export default App;
